const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchSuspected ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/txntw/v1frontend/txntw/search-suspected', params, {
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
